import React from 'react';
import DoctorDashboard from '../components/Doctor_Dashboard';

const DoctorDashboardPage: React.FC = () => <DoctorDashboard />;

export default DoctorDashboardPage;
